/* eslint-disable @typescript-eslint/no-unused-vars */
import { JsonPipe, NgFor } from '@angular/common';
import {
  Component, effect, inject, input,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { BoldFontWeightDirective } from '@shared/core/directives/bold-font-weight.directive';
import { USState } from '@shared/core/interfaces/us-state.interface';
import { FormDataService } from '@shared/core/services/form-data.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ListboxModule } from 'primeng/listbox';
import { CompatibleStates } from '@shared/core/helpers/compatibleStates';
import { InfoModalComponent } from '@shared/core/modules/info-modal/info-modal.component';

@Component({
  selector: 'app-dropdown-list',
  standalone: true,
  imports: [
    ListboxModule,
    FormsModule,
    NgFor,
    BoldFontWeightDirective,
    JsonPipe,
  ],
  templateUrl: './dropdown-list.component.html',
  styleUrl: './dropdown-list.component.scss',
  providers: [
    BoldFontWeightDirective,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DropdownListComponent,
    },
    DialogService,
  ],
})
export class DropdownListComponent implements ControlValueAccessor {
  public formService = inject(FormDataService);

  public states: USState[] = [];

  public selectedState:string | null = null;

  public label = input<string>();

  dialogRef: DynamicDialogRef | undefined;

  dialogService = inject(DialogService);

  constructor() {
    effect(() => {
      this.selectedState = this.formService.dropdownFilterSignal();
    });
  }

  onChange = (state: USState | null) => {};

  onTouched = () => {};

  writeValue(obj: any): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectOption(state: USState) {
    const isDisallowed = CompatibleStates.isIncompatible(state);
    if (isDisallowed) {
      this.showModal();
      this.selectedState = null;
      this.onChange(null);
    } else {
      this.selectedState = state.name;
      this.onChange(state);
    }
  }

  updateFilter(event: Event) {
    this.formService.updateDropdownFilter(
      (event.target as HTMLInputElement).value,
    );
  }

  showModal() {
    const config = {
      modal: true,
      breakpoints: {
        '600px': '90vw',
      },
      style: { width: '452px' },
      dismissableMask: true,
    };
    this.dialogRef = this.dialogService.open(InfoModalComponent, config);
  }
}
